import { render, staticRenderFns } from "./ReportLiabilityDamage.vue?vue&type=template&id=2d097af9&scoped=true"
import script from "./ReportLiabilityDamage.vue?vue&type=script&lang=ts"
export * from "./ReportLiabilityDamage.vue?vue&type=script&lang=ts"
import style0 from "./ReportLiabilityDamage.vue?vue&type=style&index=0&id=2d097af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d097af9",
  null
  
)

export default component.exports